import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Channel } from '../models/Channel.Model';
import { Route } from '../models/Route.Model';
import { Unit } from '../models/Unit.Model';
import { GenericService } from '../services/GenericServices';

export type TypeMode = 'default' | 'channel' | 'route' | 'organization' | 'region';

@Component({
  selector: 'aph-custom-select',
  templateUrl: './aph-custom-select.component.html',
  styleUrls: ['./aph-custom-select.component.scss']
})
export class AphCustomSelectComponent implements OnInit, OnChanges{

 // Configuración de datos
  @Input() items: any[] = [];
  @Input() type: TypeMode = 'default'; 
  @Input() filter: string = '';
  @Input() org: string = '';
  @Input() userId: string = '';
  @Input() ceveId: string = '';
  @Input() bindLabel: string = 'text';
  @Input() bindValue: string = 'id';
  @Input() placeholder: string = 'Seleccione una opción';
  
  // Opción por defecto (ej. "Todos")
  @Input() disabled: boolean = false;
  @Input() showDefaultOption: boolean = false;
  @Input() defaultLabel: string = 'Todos';
  @Input() selectedValue: any = null;
  @Input() defaultValue: any = 0;

  @Input() value: any;
  @Output() returnValue = new EventEmitter<any>();

  // Eventos de salida
  @Output() onSelectionChange = new EventEmitter<void>();
  @Output() onSelectionChangeWhitValue = new EventEmitter<any>();
  @Output() onInputBlur = new EventEmitter<void>();

  constructor(
    private apiService: GenericService,
    private cd: ChangeDetectorRef
  ) {}  

  // Se dispara cuando hay cambios en los @Input
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    // 1. Detectar si el valor seleccionado cambió desde el padre
    if (changes.selectedValue) {
      this.value = changes.selectedValue.currentValue;
      this.cd.detectChanges(); // Forzamos a que el ngx-select se entere
    }

    // 2. Recargar items
    if (changes.items || changes.filter || changes.ceveId || changes.org || changes.userId) {
      if (this.type === 'default' || this.type === undefined) {
        this.applyDefaultOption();
      } else {
        await this.sendItems();
      }
    }
  }

  private applyDefaultOption(): void {
    if (this.showDefaultOption && this.items) {
      // Evitamos duplicar la opción si ya existe
      const exists = this.items.some(item => item[this.bindValue] == this.defaultValue);
      
      if (!exists) {
        const defaultOpt = { 
          [this.bindLabel]: this.defaultLabel, 
          [this.bindValue]: this.defaultValue 
        };
        this.items = [defaultOpt, ...this.items];
      }
    }
    this.cd.detectChanges(); // Importante para refrescar la vista
  }

  async sendItems(): Promise<void> {
    let data: any[] = [];
    //evento que refresca los datos del select dependiendo del tipo
    switch (this.type) {
      case 'channel':
        if(this.filter.length > 0) {  
          data = await this.apiService.getRequest(`route/channel/${this.filter}`, {}, 0).toPromise() as Channel[];
        }else{
          data = await this.apiService.getRequest(`channel`, {}, 0).toPromise() as Channel[];
        }
        this.bindLabel = 'ChannelName';
        this.bindValue = 'ChannelCode';
        break;  
      case 'route':
        if(this.filter.length > 0) {  
          data = await this.apiService.getRequest(`route/byChannel/${this.ceveId}/0`, {}, 0).toPromise() as Route[];
          data = data.filter(s => s.ChannelCode == this.filter.toString());
        }else{
          data = await this.apiService.getRequest(`route/byChannel/${this.ceveId}/0`, {}, 0).toPromise() as Route[];
        }
        this.bindLabel = 'RouteName';
        this.bindValue = 'RouteId';
        break;  
      case 'organization':
        data = await this.apiService.getRequest(`userprofile/organizationbyuser/${this.org}/${this.userId}`, {}, 0).toPromise() as Unit[];
        this.bindLabel = 'UnitDescription';
        this.bindValue = 'UnitId';
        break;  
      case 'region':
        if(this.filter.length > 0) {  
          data = await this.apiService.getRequest(`userprofile/regions/${this.org}/${this.userId}/${this.filter}`, {}, 0).toPromise() as Unit[];
        }else{
          data = await this.apiService.getRequest(`userprofile/regions/${this.org}/${this.userId}/0`, {}, 0).toPromise() as Unit[];
        }
        this.bindLabel = 'UnitDescription';
        this.bindValue = 'UnitId';
        break;  
  
    }
    if (this.showDefaultOption && data) {
      const defaultOpt = { [this.bindLabel]: this.defaultLabel, [this.bindValue]: this.defaultValue };
      this.items = [defaultOpt, ...data];
    } else {
      this.items = data || [];
    }
    this.cd.detectChanges()
  }

  //valida las entradas y carga la opción por defecto si es necesario
  async ngOnInit(): Promise<void> {
    await this.sendItems();
    if (this.showDefaultOption) {
        const defaultOpt = { [this.bindLabel]: this.defaultLabel, [this.bindValue]: this.defaultValue };
        this.items = [defaultOpt, ...this.items];
    }
  }

  // Se dispara cuando cambia la selección
  public doSelect(event: any): void {
    this.returnValue.emit(event);
    this.value = event;
    this.onSelectionChange.emit();
    this.onSelectionChangeWhitValue.emit(event);
  }

  // Se dispara al perder el foco
  public doBlur(): void {
    this.onInputBlur.emit();
  }
  

}